// Wins. Only a rite's best is kept: the fewest moves, the least help, and
// whether it was ever won with no help at all.

import { dropPlaying, type Best, type Millis, type Progress } from "./progress.ts"
import type { Rite } from "./rite.ts"

export type Win = { readonly made: number; readonly aid: number }

const better = (a: number, b: number | undefined): number => (b === undefined ? a : Math.min(a, b))

const isPure = (win: Win): boolean => win.aid === 0

const bestOf = (win: Win, now: Millis, prev: Best | undefined): Best => ({
  moves: better(win.made, prev?.moves),
  aid: better(win.aid, prev?.aid),
  pure: (prev?.pure ?? false) || isPure(win),
  at: now,
})

// Record a win: the best for that rite. The rite is no longer in play.
export const recordWin = (progress: Progress, rite: Rite, win: Win, now: Millis): Progress => ({
  ...dropPlaying(progress, rite.id),
  solved: { ...progress.solved, [rite.id]: bestOf(win, now, progress.solved[rite.id]) },
})
